module.exports = __webpack_public_path__ + "img/wordpress.f369b005.svg";